
import XTABLES_ACTION_TYPES from "../xTablesReduxActionTypes";


const INITIAL_STATE = {
  view: "",
  lanes: [],
  cardToLane: {},
  deletedCardIds: [],
  insertedCards: [],
  updatedCards: [],
  dependencyMap: {},
};

const cardViewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case XTABLES_ACTION_TYPES.SET_VIEW:
      return {
        ...state,
        view: action.view || state.view,
      };

      case XTABLES_ACTION_TYPES.INIT_CARD_VIEW: {
 
        const lanes = action.payload || [];
      
        const cardToLane = {};
      
        lanes.forEach(lane => {
          const laneKey = lane.user?.username || "Uncategorized";
      
          // 🔹 NEW SHAPE: lane has subLanes
          if (Array.isArray(lane?.subLanes)) {
            lane?.subLanes.forEach(subLane => {
              subLane.cards?.forEach(card => {
                if (card?.id) {
                  cardToLane[card.id] = laneKey;
                }
              });
            });
            return;
          }
      
          // 🔹 OLD SHAPE: lane has cards
          if (Array.isArray(lane.cards)) {
            lane.cards.forEach(card => {
              if (card?.id) {
                cardToLane[card.id] = laneKey;
              }
            });
          }
        });
      
        return {
          ...state,
          lanes,
          cardToLane,
        };
      }
      


    case XTABLES_ACTION_TYPES.DELETE_CARD_FROM_LANE_SUCCESS: {
      const {
        deletedCardIds,
        updatedRows,
        dependencyMap,
        gridChangesPerSaveSession,
      } = action.payload;

      const deleteSet = new Set(deletedCardIds);

      /* ---------------- Remove cards ---------------- */
      let lanes = state.lanes.map(lane => ({
        ...lane,
        cards: lane.cards.filter(card => !deleteSet.has(card.id)),
      }));

      /* ---------------- Update parent cards (rollup) ---------------- */
      if (updatedRows?.length) {
        const updatedMap = new Map(
          updatedRows.map(row => [row.id, row])
        );

        lanes = lanes.map(lane => ({
          ...lane,
          cards: lane.cards.map(card => {
            const updated = updatedMap.get(card.id);
            if (!updated) return card;

            return {
              ...card,
              ...updated,
              rowIndex: card.rowIndex,
            };
          }),
        }));
      }


      /* ---------------- Update cardToLane ---------------- */
      const cardToLane = { ...state.cardToLane };
      deleteSet.forEach(id => delete cardToLane[id]);

      return {
        ...state,
        lanes,
        cardToLane,
        deletedCardIds: [
          ...state.deletedCardIds,
          ...deletedCardIds,
        ],
        dependencyMap,
        gridChangesPerSaveSession,
      };
    }
    case XTABLES_ACTION_TYPES.UPDATE_CARD_IN_LANE_SUCCESS: {
      const { updatedCards, groupByColumnType } = action.payload;
      if (!updatedCards || updatedCards.length === 0) return state;
    
      const isPersonLane =
        groupByColumnType === "Assignee" || groupByColumnType === "person";
    
      const getLaneKey = lane =>
        isPersonLane
          ? lane.user?.username || "Uncategorized"
          : lane.user?.username || "Uncategorized";
    
      const getCardLaneKey = card =>
        isPersonLane
          ? card.laneKey?.username || "Uncategorized"
          : card.laneKey || "Uncategorized";
    
      let lanes = [...state.lanes];
    
      /* ------------------------------------
         1️⃣ Index updated cards
      ------------------------------------ */
      const updatedById = new Map();
      updatedCards.forEach(c => updatedById.set(c.id, c));
    
      /* ------------------------------------
         2️⃣ Replace cards IN PLACE (keep positions)
      ------------------------------------ */
      const replaced = new Set(); // key = cardId__laneKey
    
      lanes = lanes.map(lane => {
        const laneKey = getLaneKey(lane);
    
        const newCards = lane.cards.map(card => {
          if (!updatedById.has(card.id)) return card;
    
          const updated = updatedById.get(card.id);
          const newLaneKey = getCardLaneKey(updated);
    
          if (newLaneKey === laneKey) {
            replaced.add(`${card.id}__${laneKey}`);
            return updated; // 🔥 replace without moving
          }
    
          return card; // will be moved later
        });
    
        return { ...lane, cards: newCards };
      });
    
      /* ------------------------------------
         3️⃣ Remove outdated copies
      ------------------------------------ */
      lanes = lanes.map(lane => {
        const laneKey = getLaneKey(lane);
    
        return {
          ...lane,
          cards: lane.cards.filter(card => {
            if (!updatedById.has(card.id)) return true;
            return replaced.has(`${card.id}__${laneKey}`);
          })
        };
      });
    
      /* ------------------------------------
         4️⃣ Insert moved / new cards
      ------------------------------------ */
      updatedCards.forEach(card => {
        const laneKey = getCardLaneKey(card);
        const key = `${card.id}__${laneKey}`;
    
        // already replaced in same lane
        if (replaced.has(key)) return;
    
        let laneIndex = lanes.findIndex(l => getLaneKey(l) === laneKey);
    
        if (laneIndex === -1) {
          lanes.push({
            user: isPersonLane ? card.laneKey : { username: laneKey },
            cards: []
          });
          laneIndex = lanes.length - 1;
        }
    
        lanes[laneIndex].cards.push(card);
      });
    
      /* ------------------------------------
         5️⃣ Update cardToLane
      ------------------------------------ */
      const cardToLane = { ...state.cardToLane };
      updatedCards.forEach(card => {
        cardToLane[card.id] = getCardLaneKey(card);
      });
    
      return {
        ...state,
        lanes,
        cardToLane
      };
    }
    
    default:
      return state;
  }
};

export default cardViewReducer;
